import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectRoomType = createSelector(selectJsonQuery, jsonQuery => getTermsValue('room')(jsonQuery));
